<template>
	<a-page-header
		style="border: 1px solid rgb(235, 237, 240);"
		@back="() => $router.go(-1)"
	>
		<template slot="tags">
			<a
				@click="redirect"
				class="mr-2"
				style="font-weight:bold;font-size:large;cursor: pointer;"
				:style="{ color: detail.color }"
			>
				{{ detail.profileName
				}}<i
					class="fa fa-external-link"
					style="margin-left:5px;"
					aria-hidden="true"
				></i
			></a>
			<a-tag color="blue">
				{{ detail.accountTypeName }}
			</a-tag>
			<a-tag color="red">
				{{ detail.aGName }}
			</a-tag>
			<a-select
				:defaultValue="detail.networkName"
				style="width: 120px;"
				@change="handleChange"
			>
				<a-select-option
					v-for="(net, key) in networks"
					v-bind:value="net.id"
					v-bind:key="key"
				>
					{{ net.name }}
				</a-select-option>
			</a-select>
		</template>
		<a-row type="flex" :gutter="24">
			<a-col>
				<app-image
					:src="detail.profilePicture"
					style="height:70px;border-radius: 50px;"
				/>
			</a-col>
			<a-col>
				<a-statistic title="Followers" :value="detail.followers" />
			</a-col>
			<a-col v-if="detail.networkName === 'Instagram'">
				<a-statistic title="Post" :value="detail.posts" />
			</a-col>
			<a-col v-if="detail.networkName === 'Instagram'">
				<a-statistic title="Images" :value="detail.images" />
			</a-col>
			<a-col>
				<a-statistic title="Videos" :value="detail.videos" />
			</a-col>
			<a-col>
				<a-statistic title="AVG Comments" :value="detail.comments">
					<template #suffix>
						<span> / per post</span>
					</template>
				</a-statistic>
			</a-col>
			<a-col>
				<a-statistic title="AVG Likes" :value="detail.likes">
					<template #suffix>
						<span> / per post</span>
					</template>
				</a-statistic>
			</a-col>
		</a-row>
	</a-page-header>
</template>

<script>
import AppImage from '../Image'
export default {
	name: 'DetailTitle',
	components: {
		AppImage,
	},
	props: {
		detail: {
			type: Object,
			required: true,
		},
		networks: {
			type: Array,
			required: true,
		},
	},
	data: function() {
		return {
			networkUrl: '',
		}
	},
	created() {},
	methods: {
		handleChange(evt) {
			this.$emit('networkTitleChange', evt)
		},
		redirect() {
			if (this.detail.networkName === 'Youtube') {
				window.open(`https://www.youtube.com/channel/${this.detail.profileId}`)
			}
			if (this.detail.networkName === 'Instagram') {
				window.open(`https://www.instagram.com/${this.detail.profileName}`)
			}
			if (this.detail.networkName === 'TikTok') {
				window.open(`https://www.tiktok.com/@${this.detail.profileName}`)
			}
		},
	},
}
</script>

<style></style>
